
export class RutaModel {

  origenLocalidad: string;
  destinoLocalidad: string;
  destinoCentro: string;
  paradas: [];
  paradasSolicitadas: [];
  plazas: string;
  creador: object;
  sinCoche: string;
  usuarios: [];
  cerrada: boolean;
  aceptaParadas: string;
  fechaInicio;
  fechaFin ;
  finDeSemana;

}
